// ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ ignore = [] }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!ignore.includes(pathname)) {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
